module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_illgau-678b21f796ecde8bb2b6edcf1d0cb959.png";